import { PartnerConfigType } from '~/enums/PartnerConfig';
import type { PartnerConfig } from '~/models/partnerConfig';
import {ref} from "vue";

export const usePartnerConfig = () => {
  const { apiService } = useApi();
  const config = useState<PartnerConfig | null>('config', () => null);
  const landing = useState('landing', () => '');
  const title = useState('title', () => '') ;
  const domain = useState('domain', () => '') ;
  const supportEmail = useState('supportEmail', () => '') ;
  const telegramLink = useState('telegramLink', () => '');
  const userLocale = useState('userLocale', () => '');
  const countryCode = useState('userCountry', () => '');
  const qrValue = ref("https://u.wechat.com/kNduMQOB2r5n4uwMRb5Acr8?s=2");
  const weechatLink = useState('weechatLink', () => '');
  const whatsappLink = useState('whatsappLink', () => 'https://wa.me/qr/KVRFH6WEKJIXI1');
  const weechatName = useState('weechatName', () => '');

  const userCountry = computed(() => {
    const code = countryCode.value?.toLowerCase() ?? null;
    return code ? new Intl.DisplayNames(['ru'], { type: 'region' }).of(code.toUpperCase()) : '';
  });

  async function getCountryCode() {
    try {
      if (!countryCode.value) {
        const resp = await apiService.get('ip/country');
        countryCode.value = resp.iso_code;
      }
    } catch (err: any) {
      console.error(err.message);
    }
  }

  async function getPartnerConfig() {
    try {
      if (!config.value) {
        config.value = await apiService.get('partner/config') as PartnerConfig;
        title.value = config.value?.data.find((e: { slug: string }) => e.slug === PartnerConfigType.TITLE).value ?? 'Proxy';
        domain.value = config.value?.domain ?? '';
        userLocale.value = config.value?.user.geo.countryCode?.toLowerCase() ?? '';
        landing.value = config.value?.data.find((e: { slug: string }) => e.slug === PartnerConfigType.LANDING).value ?? '';
        supportEmail.value = config.value?.data.find((e: { slug: string }) => e.slug === PartnerConfigType.SUPPORT_EMAIL).value ?? '';
        telegramLink.value = config.value?.data.find((e: { slug: string }) => e.slug === PartnerConfigType.SUPPORT_TG).value ?? '';
        weechatLink.value = config.value?.data.find((e: { slug: string }) => e.slug === PartnerConfigType.SUPPORT_WEECHAT).value ?? '';
        weechatName.value = config.value?.data.find((e: { slug: string }) => e.slug === PartnerConfigType.SUPPORT_WEECHAT_NAME).value ?? '';
      }
    } catch (err: any) {
      console.error(err.message);
    }
  }

  return {
    landing,
    config,
    title,
    domain,
    supportEmail,
    telegramLink,
    userLocale,
    countryCode,
    userCountry,
    qrValue,
    weechatLink,
    whatsappLink,
    weechatName,
    getCountryCode,
    getPartnerConfig,
  }
}